import mobile from 'is-mobile'

const baseMixin = {
  computed: {},
  methods: {
    timeStamp2String (time) {
      var datetime = new Date()
      datetime.setTime(time * 1000)
      var hour = datetime.getHours().toString()
      var minute = datetime.getMinutes().toString()
      var second = datetime.getSeconds().toString()
      return hour.padStart(2, '0') + ':' + minute.padStart(2, '0') + ':' + second.padStart(2, '0')
    },
    timeStamp2FullString (time) {
      var datetime = new Date()
      datetime.setTime(time * 1000)
      var year = datetime.getFullYear().toString()
      var month = (datetime.getMonth() + 1).toString()
      var day = datetime.getDate().toString()
      var hour = datetime.getHours().toString()
      var minute = datetime.getMinutes().toString()
      var second = datetime.getSeconds().toString()
      return year.padStart(2, '0') + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0') + ' ' + hour.padStart(2, '0') + ':' + minute.padStart(2, '0') + ':' + second.padStart(2, '0')
    },
    timeStamp2Date (time) {
      var datetime = new Date()
      datetime.setTime(time * 1000)
      var year = datetime.getFullYear().toString()
      var month = (datetime.getMonth() + 1).toString()
      var day = datetime.getDate().toString()
      return year.padStart(2, '0') + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0')
    },
    timeStamp2Time (time) {
      var datetime = new Date()
      datetime.setTime(time * 1000)
      let hour = datetime.getHours().toString()
      let minute = datetime.getMinutes().toString()
      let second = datetime.getSeconds().toString()
      return hour.padStart(2, '0') + ':' + minute.padStart(2, '0') + ':' + second.padStart(2, '0')
    },
    dateStringFormat (date) {
      return date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8) + ' ' + date.substring(8, 10) + ':' + date.substring(10, 12) + ':' + date.substring(12, 14)
    },
    utcDateStringFormat (date) {
      var datetime = new Date(date)
      var year = datetime.getFullYear().toString()
      var month = (datetime.getMonth() + 1).toString()
      var day = datetime.getDate().toString()
      var hour = datetime.getHours().toString()
      var minute = datetime.getMinutes().toString()
      var second = datetime.getSeconds().toString()
      return year.padStart(2, '0') + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0') + ' ' + hour.padStart(2, '0') + ':' + minute.padStart(2, '0') + ':' + second.padStart(2, '0')
    },
    randomRowKey (record) {
      return parseInt(Math.random() * 10000)
    },
    isIPv6 (str) {
      let pattern = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/
      return pattern.test(str)
    },
    checkEnv () {
      if (!mobile()) {
        return 'web'
      }
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        return 'wechat'
      } else {
        return 'h5'
      }
    },
    isWeChat () {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    validateEmail (email) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return regex.test(email)
    }
  },
  filters: {
    utcDateStringFormat (date) {
      var datetime = new Date(date)
      var year = datetime.getFullYear().toString()
      var month = (datetime.getMonth() + 1).toString()
      var day = datetime.getDate().toString()
      var hour = datetime.getHours().toString()
      var minute = datetime.getMinutes().toString()
      var second = datetime.getSeconds().toString()
      return year.padStart(2, '0') + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0') + ' ' + hour.padStart(2, '0') + ':' + minute.padStart(2, '0') + ':' + second.padStart(2, '0')
    },
    timestamp2date (time) {
      if (typeof time === 'undefined') {
        return '-'
      }
      const datetime = new Date()
      datetime.setTime(time * 1000)
      const year = datetime.getFullYear().toString()
      const month = (datetime.getMonth() + 1).toString()
      const day = datetime.getDate().toString()
      const hour = datetime.getHours().toString()
      const minute = datetime.getMinutes().toString()
      const second = datetime.getSeconds().toString()
      return year.padStart(2, '0') + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0') + ' ' + hour.padStart(2, '0') + ':' + minute.padStart(2, '0') + ':' + second.padStart(2, '0')
    },
    tradeStatusFilter (val) {
      const itemMap = {
        0: '未支付',
        1: '已支付',
        2: '已发货',
        3: '取消',
        10: '已到达',
        20: '已完成'
      }
      return itemMap[val]
    },
    vodSourceFilter (val) {
      if (val === '') {
        return ''
      }
      const itemMap = JSON.parse(window.localStorage.getItem('vod_sources'))
      for (let source of itemMap) {
        if (source.sourceKey === val) {
          return source.name
        }
      }
      return '其他'
    }
  }
}

export {
  baseMixin
}



// WEBPACK FOOTER //
// ./src/libs/app-mixin.js